import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourPartnerInLifelongHealth from "./sections/YourPartnerInLifelongHealth";
import WhyChooseAlignPhysiotherapy from "./sections/WhyChooseAlignPhysiotherapy";
import CareByLifeStage from "./sections/CareByLifeStage";
import TheClose from "./sections/TheClose";
import Intro from "./sections/Intro";
import ClinicalLeadership from "./sections/ClinicalLeadership";
import VoicesOfRecovery from "./sections/VoicesOfRecovery";
import OtherForLater from "./sections/OtherForLater";
import MedicalConsultationRequest from "./sections/MedicalConsultationRequest";
import ClinicAgatasInformation from "@/reusable_sections/Footer";
import TrustBar from "./sections/TrustBar";
import Authority from "./sections/Authority";
import LauraWibaux from "./sections/LauraWibaux";
import RentalManagementPainPoints from "./sections/RentalManagementPainPoints";
export default function HomePage() {
  return <div>
      <Header />
      <YourPartnerInLifelongHealth />
      <TrustBar />
      <RentalManagementPainPoints />
      <Authority />
      <WhyChooseAlignPhysiotherapy />
      <CareByLifeStage />
      <TheClose />
      <Intro />
      <ClinicalLeadership />
      <VoicesOfRecovery />
      <LauraWibaux />
      <OtherForLater />
      <MedicalConsultationRequest />
      <ClinicAgatasInformation />
    </div>;
}